"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = exports.generateCSPHeaderValue = void 0;
__exportStar(require("./lib/csp-headers"), exports);
__exportStar(require("./lib/geo-utils"), exports);
var contentSecurity_1 = require("./lib/contentSecurity");
Object.defineProperty(exports, "generateCSPHeaderValue", { enumerable: true, get: function () { return contentSecurity_1.generateCSPHeaderValue; } });
var transformation_1 = require("./lib/transformation");
Object.defineProperty(exports, "transform", { enumerable: true, get: function () { return transformation_1.transform; } });
//# sourceMappingURL=index.js.map